import Util from "../../../utils/util";
const Environment = Util.getEnvironment(); // 获取运行环境

export const getMpHost = () => {
    const map = {
        test: '//test-uis.mp.sohu.com',
        pre: '//uis.mp.sohu.com',
        prod: '//uis.mp.sohu.com',
    }
    return map[Environment]
}

export const getInterationHost = () => {
    const map = {
        test: '//test-uis.mp.sohu.com/comment',
        pre: '//uis.mp.sohu.com/comment',
        prod: '//uis.mp.sohu.com/comment',
    }
    return map[Environment]
}
